var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"spinner-container d-flex justify-content-center"},[_c('div',{class:[_vm.type, _vm.color, _vm.sizeClass],attrs:{"role":"status"}})])}
var staticRenderFns = []

export { render, staticRenderFns }